import { render, staticRenderFns } from "./draw-path-setting.vue?vue&type=template&id=51182506&scoped=true"
import script from "./draw-path-setting.vue?vue&type=script&lang=js"
export * from "./draw-path-setting.vue?vue&type=script&lang=js"
import style0 from "./draw-path-setting.vue?vue&type=style&index=0&id=51182506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51182506",
  null
  
)

export default component.exports